export default "<span *ngIf=\"!auto\" (click)=\"getPost()\">\n  <ng-content></ng-content>\n</span>\n"